/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Refresh_TitleInputs */



/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Event_Templates_Refresh_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_refresh_title = /** @type {((inputs?: Event_Templates_Refresh_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Refresh_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Refrescar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リフレッシュ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ताज़ा करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar")
	return /** @type {LocalizedString} */ ("Refresh")
});